import randomstring from  "randomstring";

export default function generateRandomString(stringLength) {
	return randomstring.generate({
        length: stringLength
    });
}


// WEBPACK FOOTER //
// ./src/core/utils/generateRandomString.js